// ==================== PLATFORM SETTINGS SERVICE ====================

import apiService from './api';
import type { ApiResponse } from '../types';

export interface PlatformSettings {
  id: string;
  platformName: string;
  platformLogo: string | null;
  supportEmail: string | null;
  defaultCurrency: string;
  updatedAt: string;
}

export interface UpdatePlatformSettingsDto {
  platformName?: string;
  supportEmail?: string;
  defaultCurrency?: string;
  platformLogo?: string;
}

const platformSettingsService = {
  /**
   * Get platform settings
   */
  getSettings: async (): Promise<ApiResponse<PlatformSettings>> => {
    return apiService.get<PlatformSettings>('/admin/platform-settings');
  },

  /**
   * Update platform settings
   */
  updateSettings: async (data: UpdatePlatformSettingsDto): Promise<ApiResponse<PlatformSettings>> => {
    return apiService.patch<PlatformSettings>('/admin/platform-settings', data);
  },
};

export default platformSettingsService;

